module.exports = __webpack_public_path__ + "tb-wireframe4.jpg?5ce28662f015e10b9c15eec74b2d3ec1";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/tb-wireframe4.jpg
// module id = 243
// module chunks = 0